import { render, staticRenderFns } from "./ProductSettings.vue?vue&type=template&id=37ef6f32&scoped=true&"
import script from "./ProductSettings.vue?vue&type=script&lang=js&"
export * from "./ProductSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductSettings.vue?vue&type=style&index=0&id=37ef6f32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef6f32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ef6f32')) {
      api.createRecord('37ef6f32', component.options)
    } else {
      api.reload('37ef6f32', component.options)
    }
    module.hot.accept("./ProductSettings.vue?vue&type=template&id=37ef6f32&scoped=true&", function () {
      api.rerender('37ef6f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductSettings.vue"
export default component.exports